import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createTestimonial,
  getAllTestimonial,
  getTestimonialByID,
  TestimonialImageUpload,
  updateTestimonial,
} from "./services/testimonial.services";
import { clearTestimonialDetails } from "./testimonialSlice";
import FormRichTextField from "../../components/formFields/FormRichTextField";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { RxCross1 } from "react-icons/rx";
import FormImageUploadMorden from "../../components/formFields/formImageUploadMorden";

const CreateTestimonial: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  // const location = useLocation();
  // const TestimonialID = location.state?.TestimonialID;
  const TestimonialID = useAppSelector((state) => state.muidrawer.data);
  const TestimonialDetail = useAppSelector(
    (state) => state.testimonial.TestimonialDetail
  );
  const loading = useAppSelector((state) => state.testimonial.formLoading);
  const [formKey, setFormKey] = React.useState(1);

  useEffect(() => {
    if (TestimonialID) {
      dispatch(getTestimonialByID(TestimonialID));
    }
    return () => {
      dispatch(clearTestimonialDetails());
    };
  }, [TestimonialID]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [TestimonialDetail]);

  const handleSubmit = async (values: any) => {
    const formData = {
      CustomerName: values.CustomerName ? values.CustomerName : "",
      Description: values.Description ? values.Description : "",
      UniversityName: values.UniversityName ? values.UniversityName : "",
      TestimonialURL: values.TestimonialURL ? values.TestimonialURL : "",
      IsActive: values.IsActive === 1,
    };
    const ImageData = new FormData();
    const TestimonialImage =
      values?.TestimonialImage &&
      typeof values?.TestimonialImage !== "string" &&
      Array.isArray(values?.TestimonialImage) &&
      values?.TestimonialImage?.length > 0
        ? values.TestimonialImage[0].getRawFile()
        : "";

    try {
      if (TestimonialID) {
        const editPayload = {
          ...formData,
          ID: TestimonialID,
        };

        const response = await dispatch(updateTestimonial(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());

          if (
            values?.TestimonialImage &&
            typeof values?.TestimonialImage !== "string" &&
            Array.isArray(values?.TestimonialImage) &&
            values?.TestimonialImage?.length > 0
          ) {
            ImageData.append("TestimonialImage", TestimonialImage);
            ImageData.append("ID", TestimonialID);
            await dispatch(TestimonialImageUpload(ImageData));
          }
          dispatch(getAllTestimonial());
          dispatch(clearTestimonialDetails());
        }
      } else {
        const response = await dispatch(createTestimonial(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          if (
            values?.TestimonialImage &&
            typeof values?.TestimonialImage !== "string" &&
            Array.isArray(values?.TestimonialImage) &&
            values?.TestimonialImage?.length > 0 &&
            response?.payload?.Data?.ID
          ) {
            ImageData.append("TestimonialImage", TestimonialImage);

            ImageData.append("ID", response?.payload?.Data?.ID);
            await dispatch(TestimonialImageUpload(ImageData));
          }
          dispatch(getAllTestimonial());
          dispatch(clearTestimonialDetails());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={TestimonialDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
                <GridLayoutItem className="master-drawer-header">
                  <Typography.h4 className="m-0">
                    {TestimonialID
                      ? "Update Testimonial"
                      : "Create Testimonial"}
                  </Typography.h4>
                  <Button
                    type="button"
                    fillMode={"flat"}
                    themeColor={"dark"}
                    style={{ marginRight: 4 }}
                    onClick={() => dispatch(closed())}
                  >
                    <RxCross1 />
                  </Button>
                </GridLayoutItem>
                {/* <GridLayoutItem >
                  <Field
                    name="TestimonialURL"
                    label="Testimonial URL"
                    placeholder="i.e. studyabroadusa "
                    component={FormTextField}
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                </GridLayoutItem> */}
                <GridLayoutItem>
                  <Field
                    name="CustomerName"
                    label="Customer Name "
                    placeholder="Customer Name "
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="UniversityName"
                    label="University Name "
                    placeholder="University Name"
                    component={FormTextField}
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="Description"
                    label="Description"
                    component={FormRichTextField}
                    style={{ height: 120 }}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    justifyContent="start"
                    name={`TestimonialImage`}
                    label="Testimonial Image"
                    type="file"
                    accept="image/*"
                    alternateName="Testimonial Image"
                    component={FormImageUploadMorden}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`IsActive`}
                    label="Status"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={TestimonialID ? "Update" : "Create"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => dispatch(closed())}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateTestimonial;
